/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LCodeRouteImport } from './routes/l.$code'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedNewRouteImport } from './routes/_authenticated/new'
import { Route as AuthenticatedQuestionnaireSubmissionIdRouteImport } from './routes/_authenticated/questionnaire.$submissionId'
import { Route as AuthenticatedCompleteSubmissionIdRouteImport } from './routes/_authenticated/complete.$submissionId'

const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LCodeRoute = LCodeRouteImport.update({
  id: '/l/$code',
  path: '/l/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNewRoute = AuthenticatedNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedQuestionnaireSubmissionIdRoute =
  AuthenticatedQuestionnaireSubmissionIdRouteImport.update({
    id: '/questionnaire/$submissionId',
    path: '/questionnaire/$submissionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/questionnaire.$submissionId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompleteSubmissionIdRoute =
  AuthenticatedCompleteSubmissionIdRouteImport.update({
    id: '/complete/$submissionId',
    path: '/complete/$submissionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/new': typeof AuthenticatedNewRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/l/$code': typeof LCodeRoute
  '/complete/$submissionId': typeof AuthenticatedCompleteSubmissionIdRoute
  '/questionnaire/$submissionId': typeof AuthenticatedQuestionnaireSubmissionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/new': typeof AuthenticatedNewRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/l/$code': typeof LCodeRoute
  '/complete/$submissionId': typeof AuthenticatedCompleteSubmissionIdRoute
  '/questionnaire/$submissionId': typeof AuthenticatedQuestionnaireSubmissionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/_authenticated/new': typeof AuthenticatedNewRoute
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute
  '/l/$code': typeof LCodeRoute
  '/_authenticated/complete/$submissionId': typeof AuthenticatedCompleteSubmissionIdRoute
  '/_authenticated/questionnaire/$submissionId': typeof AuthenticatedQuestionnaireSubmissionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/privacy'
    | '/new'
    | '/onboarding'
    | '/l/$code'
    | '/complete/$submissionId'
    | '/questionnaire/$submissionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/privacy'
    | '/new'
    | '/onboarding'
    | '/l/$code'
    | '/complete/$submissionId'
    | '/questionnaire/$submissionId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/privacy'
    | '/_authenticated/new'
    | '/_authenticated/onboarding'
    | '/l/$code'
    | '/_authenticated/complete/$submissionId'
    | '/_authenticated/questionnaire/$submissionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  LCodeRoute: typeof LCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/l/$code': {
      id: '/l/$code'
      path: '/l/$code'
      fullPath: '/l/$code'
      preLoaderRoute: typeof LCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/new': {
      id: '/_authenticated/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof AuthenticatedNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/questionnaire/$submissionId': {
      id: '/_authenticated/questionnaire/$submissionId'
      path: '/questionnaire/$submissionId'
      fullPath: '/questionnaire/$submissionId'
      preLoaderRoute: typeof AuthenticatedQuestionnaireSubmissionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/complete/$submissionId': {
      id: '/_authenticated/complete/$submissionId'
      path: '/complete/$submissionId'
      fullPath: '/complete/$submissionId'
      preLoaderRoute: typeof AuthenticatedCompleteSubmissionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedNewRoute: typeof AuthenticatedNewRoute
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
  AuthenticatedCompleteSubmissionIdRoute: typeof AuthenticatedCompleteSubmissionIdRoute
  AuthenticatedQuestionnaireSubmissionIdRoute: typeof AuthenticatedQuestionnaireSubmissionIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedNewRoute: AuthenticatedNewRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
  AuthenticatedCompleteSubmissionIdRoute:
    AuthenticatedCompleteSubmissionIdRoute,
  AuthenticatedQuestionnaireSubmissionIdRoute:
    AuthenticatedQuestionnaireSubmissionIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  LCodeRoute: LCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
